import React from 'react';
import { Modal, Button, notification } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useDiagnosticReport } from '@/core/domain/reports/movements/diagnostics/Report.hooks';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { useReportHandlers } from '@/hooks/useReportHandler';

type Props = {
  visible: boolean;
  handleVisible: () => void;
};

const DiagnosticReportModal: React.FC<Props> = ({ visible, handleVisible }) => {
  const intl = useIntl();
  const { diagnosticId } = useRouteMatch<{ diagnosticId: string }>().params;

  const diagnosticReport = useDiagnosticReport();

  const { fileLoading, setFileLoading, setFileUnloading, FILE_FORMAT } =
    useFileLoading();

  const handleCancel = () => {
    handleVisible();
  };

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      const obj = {
        format: FILE_FORMAT[format],
        diagnosticId: Number(diagnosticId),
      };

      const result = await diagnosticReport.mutateAsync(obj);

      if (callback) {
        callback(result);
      }

      notification.success({
        message: 'Sucesso!',
        description: 'Relatório de diagnóstico gerado com sucesso!',
      });
      handleVisible();
    } catch {}
    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'diagnostico',
    handleGenerateReport,
  );

  const footer = [
    <SpaceForButton justifyContent="flex-end">
      <Button
        block
        type="primary"
        onClick={handleView}
        key="viewReport"
        loading={fileLoading.REPORT_VIEW}
      >
        <FormattedMessage id="customers.modal.report.buttons.viewReport" />
      </Button>

      <Button
        block
        type="primary"
        key="PDF"
        onClick={handlePdf}
        loading={fileLoading.PDF}
      >
        <FormattedMessage id="customers.modal.report.buttons.pdf" />
      </Button>

      <Button
        block
        type="primary"
        key="CSV"
        onClick={handleCsv}
        loading={fileLoading.CSV}
      >
        <FormattedMessage id="customers.modal.report.buttons.csv" />
      </Button>
    </SpaceForButton>,
  ];

  return (
    <Modal
      title={intl.formatMessage({ id: 'diagnostics.modal.report.title' })}
      open={visible}
      footer={footer}
      onCancel={handleCancel}
      width={550}
    >
      <p>
        {intl.formatMessage({
          id: 'quotations.details.report.selectReportType',
        })}
      </p>
    </Modal>
  );
};

export default DiagnosticReportModal;
